import React, { useState } from 'react';
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Stack,
	TextField,
} from '@mui/material';
import * as ShopSelectors from 'selectors/ShopSelectors';
import { FooterLinkRow } from 'common/modules/customization';
import { useTranslation } from 'services/localization';
import { isValidUrl } from 'common/modules/atoms/validation';
import { createLocaleField } from 'common/modules/translations';
import { useSelector } from 'react-redux';

export interface Props {
	onChange: (value: FooterLinkRow) => void;
	isOpen: boolean;
	onClose: () => void;
}
const LinkInformationDialog = (props: Props) => {
	const { onChange, isOpen, onClose } = props;
	const { t } = useTranslation();
	const defaultLanguage = useSelector(ShopSelectors.activeShopDefaultLanguage);
	const [newLinkInfo, setNewLinkInfo] = useState<{ label: string; url: string }>({
		label: '',
		url: '',
	});

	const disabled = !newLinkInfo.label || !newLinkInfo.url;
	const isInvalidUrl = !!newLinkInfo.url ? !isValidUrl(newLinkInfo.url) : false;

	const handleSubmit = () => {
		onChange({
			label: createLocaleField(newLinkInfo.label, defaultLanguage),
			url: newLinkInfo.url,
		});
		setNewLinkInfo({ label: '', url: '' });
		onClose();
	};

	return (
		<Dialog
			sx={{ width: '100%', height: '100%' }}
			fullWidth
			maxWidth="xs"
			open={isOpen}
			onClose={onClose}
		>
			<DialogTitle sx={{ mb: 2 }}>
				{t('channels.online.customizer.footer.links.dialog.header', 'Add new link')}
			</DialogTitle>
			<DialogContent sx={{ pt: 2 }}>
				<Stack mt={2} spacing={2}>
					<TextField
						label={t('common:form.label', 'Label')}
						value={newLinkInfo.label}
						onChange={(event) => setNewLinkInfo({ ...newLinkInfo, label: event.target.value })}
						InputLabelProps={{
							shrink: true,
						}}
						placeholder={t(
							'channels.online.customizer.footer.links.dialog.linkNamePlaceholder',
							'Add link name',
						)}
					/>
					<TextField
						label={'URL'}
						value={newLinkInfo.url}
						onChange={(event) => setNewLinkInfo({ ...newLinkInfo, url: event.target.value })}
						InputLabelProps={{
							shrink: true,
						}}
						placeholder={t('common:form.addUrl', 'Add a URL')}
						error={isInvalidUrl}
						helperText={isInvalidUrl ? t('common:form.urlError', 'Invalid url') : ''}
					/>
				</Stack>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose}>{t('common:actions.cancel', 'Cancel')}</Button>
				<Button disabled={disabled} onClick={handleSubmit}>
					{t('common:greetings.okBtn', 'Ok')}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default LinkInformationDialog;
